export const DefaultPostEditor = {
  subject: "",
  seo_request: "",
  nb_words: 1500,

  smart_redaction_outline: false,
  manually_choose_nb_words: false,
  is_manual_depth_and_length: false,
  nb_parts: 3,
  depth: 3,
  outline: "",
  outline_rewrite: "",

  url_path: "",
  nb_url_slug: 3,
  url_slug_ideas: [],
  url_slug: "",

  nb_h1_title: 3,
  h1_title_ideas: [],
  h1_title: "",

  introduction_length: "courte",
  nb_introduction: 3,
  introduction_ideas: [],
  introduction: "",

  content: "",
  content_rewrite: {},

  conclusion_length: "courte",
  transition_article: "",
  nb_conclusion: 3,
  conclusion_ideas: [],
  conclusion: "",

  nb_meta_title: 3,
  meta_title_ideas: [],
  meta_title: "",
  nb_meta_description: 3,
  meta_description_ideas: [],
  meta_description: "",

  is_table_of_content: false,
  table_of_content: "",
};
export const removeSpanTags = (html) => {
  return html.replace(/<span[^>]*>(.*?)<\/span>/g, "$1");
};
